// Mock data for The Br8k Room

export const businessInfo = {
  name: "The Br8k Room",
  tagline: "Br8k the Routine.",
  address: "2060 E US Highway 20 Michigan City, IN. 46360",
  phone: "219.243.7905",
  emails: ["nbryant@thebr8kroom.com", "aharper@thebr8kroom.com"],
  hours: {
    monday: "4pm-9pm",
    tuesday: "4pm-9pm",
    wednesday: "4pm-9pm",
    thursday: "4pm-9pm",
    friday: "1pm-9pm",
    saturday: "1pm-9pm",
    sunday: "Closed"
  },
  social: {
    facebook: "https://www.facebook.com/p/The-Br8k-Room-61582767355751/",
    instagram: "https://www.instagram.com/the.br8k.room/",
    tiktok: "https://www.tiktok.com/@the.br8k.room"
  },
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2980.123456789!2d-86.8!3d41.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDQyJzAwLjAiTiA4NsKwNDgnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
};

export const attractions = [
  {
    id: 1,
    slug: "zero-latency-vr",
    name: "Zero Latency VR",
    tagline: "Premium Free-Roam VR. Its own league.",
    description: "Our flagship premium VR experience. Walk and explore our 1,053 sq ft arena with cutting-edge free-roam technology that feels completely real.",
    features: ["Premium VR experience", "Up to 8 players", "1,053 sq ft arena", "AAA game titles"],
    icon: "Zap",
    isPremium: true,
    image: "/zero-latency.png"
  },
  {
    id: 2,
    slug: "vr-escape-rooms",
    name: "VR Escape Rooms",
    tagline: "Solve. Explore. Escape — together.",
    description: "Immersive escape rooms, puzzles, and story-driven adventures in VR. Perfect for groups seeking cooperative challenges and unforgettable moments.",
    features: ["Cooperative gameplay", "Multiple story worlds", "Family & adult modes", "60 min sessions"],
    icon: "Box",
    isPremium: false,
    image: "/vrcave.png"
  },
  {
    id: 3,
    slug: "vr-laser-tag",
    name: "VR Laser Tag",
    tagline: "High-energy team battles.",
    description: "Compete, move, and battle in immersive VR laser tag arenas. Team-based action for players of all skill levels.",
    features: ["Team-based matches", "Up to 6 players", "Multiple arenas", "All skill levels"],
    icon: "Target",
    isPremium: false,
    image: "/holomia.png"
  },
  {
    id: 4,
    slug: "free-roam-vr",
    name: "Free Roam VR",
    tagline: "Vex Play · BattleStart · SpawnPoint · Hero Zone",
    description: "Standard free-roam VR you can walk through. Multiple game modes across Vex Play, BattleStart, SpawnPoint, and Hero Zone — competitive, cooperative, and family-friendly.",
    features: ["Walk-anywhere VR", "4 game worlds", "Solo or group play", "Family-friendly content"],
    icon: "Gamepad2",
    isPremium: false,
    images: ["/vex-play.png", "/battle-start.png", "/spawnpoint.png", "/hero-zone.png"]
  },
  {
    id: 5,
    slug: "retro-arcade",
    name: "Retro Arcade",
    tagline: "40,000+ games. Three consoles.",
    description: "Three retro gaming consoles, each loaded with over 40,000 classic games. From arcade legends to console classics — relive gaming history.",
    features: ["3 gaming consoles", "40,000+ games each", "Classic arcade titles", "Multiplayer options"],
    icon: "Monitor",
    isPremium: false,
    image: "/retro-gaming.png"
  },
  {
    id: 6,
    slug: "break-room",
    name: "The Break Room",
    tagline: "Rage Room / Smash Room — done right.",
    description: "A supervised, controlled space where guests can safely break approved items. Built for fun. Designed with purpose. Structured. Responsible. Loud.",
    features: ["Safety gear provided", "Approved breakable items", "Ages 13+ with guardian", "Private sessions available"],
    icon: "Hammer",
    isPremium: false,
    fullDescription: "We built the Break Room because we believe people need healthy outlets. Not places that encourage anger — but spaces that prevent it from spilling into homes, schools, and relationships. As a faith-driven family, we wanted to create something fun, safe, and responsible — a place where people can laugh, break a little stress, and walk out feeling lighter."
  },
  {
    id: 7,
    slug: "party-packages",
    name: "Party Packages",
    tagline: "All-in-one celebration experience.",
    description: "The perfect all-in-one party for birthdays, milestones, and unforgettable memories. Multiple attractions bundled with private space and lounge access.",
    features: ["Multiple attractions", "Private table area", "Lounge with TV", "Local catering available"],
    icon: "PartyPopper",
    isPremium: true,
    photo: "/party-packages-photo.webp",
    photoPosition: "center 62%"
  },
  {
    id: 8,
    slug: "corporate-events",
    name: "Corporate & Group Events",
    tagline: "Team building your team will actually talk about.",
    description: "Team-building, holiday parties, offsites, and youth-group events. Full venue buyouts and custom experiences for groups of any size.",
    features: ["Team-building programs", "Full venue buyouts", "Custom experiences", "Flexible scheduling"],
    icon: "Users",
    isPremium: true,
    photo: "/corporate-events-photo.webp"
  }
];

export const events = [
  {
    id: 1,
    type: "Corporate Team Building",
    description: "Level up your team dynamics with collaborative VR challenges and competitive tournaments. Build trust, communication, and camaraderie through immersive experiences.",
    includes: ["Custom team challenges", "Leadership exercises", "Flexible scheduling", "Catering options available"],
    minGuests: 10
  },
  {
    id: 2,
    type: "Group Events",
    description: "Church groups, sports teams, school groups, youth organizations - we've got space and experiences for everyone. Perfect for team bonding and celebrations.",
    includes: ["Group discounts", "Flexible booking", "Multiple attractions", "All ages welcome (12+)"],
    minGuests: 8
  },
  {
    id: 3,
    type: "Private Rentals",
    description: "Want the whole place to yourselves? Book The Br8k Room for your exclusive event with full access to all attractions.",
    includes: ["Exclusive venue access", "All attractions included", "Custom scheduling", "Event coordinator"],
    minGuests: 15
  }
];

export const pricing = [
  {
    category: "Retro Arcade Stations",
    description: "Unlimited play access to over 40,000 retro arcade games",
    options: [
      { name: "1 Hour Unlimited Play", price: "$10", perPerson: true, duration: "60 min" }
    ]
  },
  {
    category: "Battle Start VR",
    description: "Standard Free-Roam VR Arena for up to 6 players",
    maxPlayers: 6,
    options: [
      { name: "30-Minute Session", price: "$25", perPerson: true, duration: "30 min / 3 games" },
      { name: "60-Minute Session", price: "$45", perPerson: true, duration: "60 min / 6 10 min games or 2 - 15 min" }
    ]
  },
  {
    category: "Shared VR Arena",
    description: "VrCave, Vex Play & SpawnPoint - Shared arena for up to 6 players",
    maxPlayers: 6,
    options: [
      { name: "30-Minute Session", price: "$25", perPerson: true, duration: "30 min / 3 games" },
      { name: "60-Minute Session", price: "$45", perPerson: true, duration: "60 min / 6 10 min games or 2 - 15 min" }
    ]
  },
  {
    category: "Zero Latency VR (Premium Free-Roam)",
    description: "Premium free-roam VR - Up to 6 players | No discounts allowed",
    maxPlayers: 6,
    noDiscounts: true,
    options: [
      { name: "Intro Mission", price: "$25", perPerson: true, duration: "15 min" },
      { name: "Premium Mission", price: "$60", perPerson: true, duration: "45 min" },
      { name: "Flagship Mission", price: "$75", perPerson: true, duration: "60 min" }
    ]
  },
  {
    category: "The Break Zone",
    description: "Supervised break experience — controlled fun, stress relief, and responsible enjoyment. Not rage. Not therapy. Just a healthy outlet.",
    options: [
      { name: "Standard Session", price: "$30", perPerson: true, duration: "30 min" }
    ]
  }
];

export const packages = [
  {
    id: "zero_latency_upgrade",
    name: "Go Premium – Zero Latency VR",
    price: 80,
    priceDisplay: "$80-$95",
    availability: "Everyday",
    subtext: "Signature Experience",
    description: "The ultimate premium VR bundle!",
    includes: [
      "Zero Latency Flagship or Premium",
      "60 min Retro Gaming",
      "Exclusive wristband or sticker"
    ],
    color: "pink",
    premium: true,
    priority: 0
  },
  {
    id: "play_more_pass",
    name: "Play More for Less Time Waiting",
    price: 55,
    priceDisplay: "$55",
    availability: "Everyday",
    subtext: "VR + Arcade + Merch Credit",
    description: "Get more play time for less!",
    includes: [
      "60 min VR (Battle Start or Shared Arena)",
      "60 min Retro Gaming",
      "$5 Merch Credit"
    ],
    color: "green",
    popular: true,
    priority: 1
  },
  {
    id: "break_and_play",
    name: "Smash It Then Play",
    price: 65,
    priceDisplay: "$65",
    availability: "Everyday",
    subtext: "Rage Room + VR + Arcade",
    description: "The ultimate stress relief combo!",
    includes: [
      "1 Break Zone Session",
      "30 min VR Experience",
      "60 min Retro Gaming"
    ],
    color: "pink",
    priority: 2
  },
  {
    id: "group_night_bundle",
    name: "Best Value for Groups",
    price: 180,
    priceDisplay: "$180",
    availability: "Everyday",
    subtext: "Up to 4 Players",
    description: "Perfect for groups of 4!",
    includes: [
      "60 min Shared VR Arena (4 players)",
      "2 hours Retro Gaming",
      "$20 Merch Credit"
    ],
    color: "green",
    forPlayers: 4,
    priority: 3
  },
  {
    id: "weekday_wind_down",
    name: "Weekday Special – Limited Time",
    price: 40,
    priceDisplay: "$40",
    availability: "Monday–Thursday Only",
    subtext: "Monday–Thursday Only",
    description: "After school/work special!",
    includes: [
      "30 min VR Experience",
      "60 min Retro Gaming"
    ],
    color: "blue",
    weekdaysOnly: true,
    priority: 4
  }
];

export const pricingPolicies = {
  waiverRequired: true,
  closedToeShoesRequired: true,
  zeroLatencyExcludedFromDiscounts: true,
  merchandiseAndFood: true,
  customGroupPackages: true,
  ageRequirements: {
    vr: "12+",
    breakZone: "13+ (with guardian)",
    under18MustBeWithAdult: true
  }
};

export const faqs = [
  {
    question: "What's the minimum age?",
    answer: "VR experiences require participants to be 12 years or older. The Break Zone requires participants to be 13+ with a guardian present. All guests under 18 must be accompanied by an adult. Waivers are required for all participants. Retro gaming consoles are all-ages friendly!"
  },
  {
    question: "Do I need a reservation?",
    answer: "Reservations are highly recommended, especially for weekends and group events. Walk-ins are welcome based on availability, but booking ahead guarantees your spot."
  },
  {
    question: "Is it safe?",
    answer: "Absolutely! Safety is our top priority. All equipment is sanitized between uses, and we provide full safety briefings before each experience. Full protective gear is included for the Break Zone."
  },
  {
    question: "What should I wear?",
    answer: "Comfortable clothes and closed-toe shoes are required. For VR experiences, avoid bulky jackets or accessories. We provide all necessary safety equipment."
  },
  {
    question: "Can I host a private event?",
    answer: "Yes! We offer private bookings for birthdays, corporate events, and group gatherings. Contact us directly to discuss your needs and customize your experience."
  },
  {
    question: "Do you offer group discounts?",
    answer: "Yes! Groups of 8 or more receive special pricing. Contact us for a custom quote based on your group size and desired experiences."
  },
  {
    question: "What if I get motion sick?",
    answer: "VR motion sickness is rare with our premium equipment, but everyone's different. Start with shorter experiences, and our staff can recommend the best options for you."
  },
  {
    question: "Can I br8k my own food?",
    answer: "Outside food and drinks are not permitted, but we're happy to work with local caterers for private events. Contact us for catering options."
  },
  {
    question: "Is the Break Zone a rage room?",
    answer: "No — we intentionally don't call it that. The Break Zone is about controlled breaks in a safe environment, not rage or anger. It's entertainment designed for fun and stress relief in a supervised, structured setting."
  },
  {
    question: "Does the Break Zone encourage bad behavior?",
    answer: "Actually, it does the opposite. By providing a structured space with rules and supervision, we keep destructive behavior out of homes and schools. The Break Zone is the ONLY place where breaking things is allowed — this is not something to copy at home or school."
  },
  {
    question: "Is the Break Zone therapy?",
    answer: "No. The Break Zone is entertainment — not counseling or treatment. It's simply a safe, physical activity designed for fun and stress relief. We offer a positive outlet, built with purpose."
  },
  {
    question: "Is the Break Zone appropriate for teens?",
    answer: "Yes — with guidelines. Ages 13+ may participate with a guardian, signed waiver, safety gear, and staff supervision. We teach safety, respect, and responsibility first — then fun."
  },
  {
    question: "Why breaking things?",
    answer: "Because when it's allowed in the right place, it keeps it from happening in the wrong ones. The Break Zone was created with intention — life can feel heavy, fast, and loud, and sometimes people just need a healthy outlet that doesn't harm others or spill into everyday life."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    rating: 5,
    text: "Amazing experience! The Zero Latency VR was mind-blowing. My kids couldn't stop talking about it for days!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Mike R.",
    rating: 5,
    text: "Best team building activity ever! The Br8k Room was exactly what our stressed team needed. Highly recommend!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jessica T.",
    rating: 5,
    text: "Spawnpoint is a nostalgia paradise! 40,000 games per console? My teenage son and I spent hours bonding over classics.",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "David K.",
    rating: 5,
    text: "Brought our whole team here for a corporate event and it was EPIC! Staff was super friendly and the VR experiences were incredible.",
    date: "1 week ago"
  },
  {
    id: 5,
    name: "Amanda L.",
    rating: 5,
    text: "This place is a hidden gem in Michigan City! 7,500 sq ft of pure fun. We'll definitely be back!",
    date: "2 months ago"
  },
  {
    id: 6,
    name: "Chris P.",
    rating: 5,
    text: "The standard VR options (Vex Play, Battle Start, VRCave) are fantastic value. Great for groups!",
    date: "3 weeks ago"
  }
];

export const eventPackages = [
  {
    id: 1,
    name: "TEAM STARTER",
    price: "$399",
    guests: "10-15 guests",
    duration: "2 hours",
    tagline: "Perfect Team Introduction",
    color: "green",
    features: [
      "2 hours of VR access",
      "Shared VR Arena experiences",
      "Team-building challenges",
      "Dedicated event host",
      "Meeting space included",
      "Basic refreshments"
    ],
    highlight: "Great for small teams"
  },
  {
    id: 2,
    name: "CORPORATE PRO",
    price: "$699",
    guests: "15-25 guests",
    duration: "3 hours",
    tagline: "Most Popular Choice",
    color: "blue",
    popular: true,
    features: [
      "3 hours of all attractions",
      "Battle Start VR tournaments",
      "Shared VR Arena experiences", 
      "The Break Zone team session",
      "Private event space",
      "Dedicated event coordinator",
      "Full catering included",
      "Team photos included",
      "Custom leaderboards"
    ],
    highlight: "Best value • Full experience"
  },
  {
    id: 3,
    name: "EXECUTIVE VIP",
    price: "$1,199",
    guests: "25-40 guests",
    duration: "4 hours",
    tagline: "The Ultimate Team Experience",
    color: "pink",
    features: [
      "4 hours unlimited access",
      "Zero Latency Premium VR",
      "All VR experiences included",
      "Retro gaming unlimited",
      "The Break Zone sessions",
      "Exclusive VIP venue rental",
      "Personal event coordinator",
      "Premium catering & bar",
      "Custom team challenges",
      "Professional photography",
      "Branded merchandise",
      "Post-event highlights video"
    ],
    highlight: "Complete venue buyout • Premium service"
  }
];